<template>
  <div v-if="snackbar" class="toast toast-end z-2000">
    <div class="alert bg-primary text-white">
      An update is available. Please save your work and refresh.
      <app-button @click="refresh" class="text-xs">Refresh</app-button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import AppButton from '@/components/v2/AppButton.vue';

export default {
  name: 'VersionNotifier',
  components: { AppButton },
  data: () => ({
    interval: Number(import.meta.env.VITE_VERSION_NOTIFIER_INTERVAL) || 5000,
    snackbar: false,
    intervalId: 0,
  }),
  methods: {
    refresh() {
      window.location.reload();
    },
    async getDeployedSha() {
      try {
        const base = import.meta.env.BASE_URL || '/';
        const url = `${base}version.json?t=${Date.now()}`;
        const { data } = await axios.get(url, { headers: { 'Cache-Control': 'no-cache' } });
        return data?.sha || null;
      } catch {
        return null;
      }
    },
    startPolling() {
      if (this.interval < 0) return;
      this.intervalId = window.setInterval(async () => {
        const deployed = await this.getDeployedSha();
        if (deployed && deployed !== __BUILD_SHA__) {
          this.snackbar = true;
          clearInterval(this.intervalId);
        }
      }, this.interval);
    },
  },
  mounted() {
    this.startPolling();
  },
  unmounted() {
    clearInterval(this.intervalId);
  },
};
</script>
